import { SITES } from '../gen/lang.js';
import { isSupportedLocale, getLanguageFromLocale } from './langService.js';

const getCookie = (key) => {
    const b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
};
const setCookie = (name, value, expireDays) => {
    const date = new Date();
    date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + '; ' + expires + '; path=/';
};
const setLocaleCookie = (site, locale) => {
    // we only set a locale cookie for sites that have more than one defined locale
    if (site.alternateLocales.length && isSupportedLocale(locale, site.id)) {
        return setCookie('_zpLanguage', getLanguageFromLocale(locale), 180);
    }
};
const findSiteFromUrl = () => {
    const domainRegex = /[\w-]+\.?\w{2}?\.\w{2,3}$/;
    const currentCountry = window.location.hostname.match(domainRegex);
    return SITES.find((site) => site.domain === currentCountry?.[0]);
};
const findLocaleFromUrlAndCookie = () => {
    const site = findSiteFromUrl();
    if (!site) {
        return 'de-DE';
    }
    // we get locale from cookie only for sites that have more than one defined locale
    if (site.alternateLocales.length) {
        const split = window.location?.pathname?.split('/') || [];
        const urlLanguage = split[1];
        const language = site.language === urlLanguage
            ? site.locale
            : site.alternateLocales.find((alt) => alt.language === urlLanguage)?.locale;
        if (language) {
            return language;
        }
        console.log(document.cookie);
        const cookieLanguage = getCookie('_zpLanguage');
        if (cookieLanguage) {
            return site.language === cookieLanguage
                ? site.locale
                : site.alternateLocales.find((alt) => alt.language === cookieLanguage)?.locale;
        }
    }
    return site.locale;
};

export { findLocaleFromUrlAndCookie, findSiteFromUrl, getCookie, setCookie, setLocaleCookie };
//# sourceMappingURL=cookieService.js.map
